/* Sero Article Kit v2: theme behavior for the article template (Blog Refresh Wave 1).
   Vanilla, no dependencies, safe to run once per page. Loaded by sections/main-article.liquid
   when its kit layout is on.
   What it does:
   - In this guide: highlights the current section in the desktop rail, fills the rail's
     progress bar, keeps the current row in view when the rail scrolls, and clears the
     highlight above the first section.
   - Events (GA4 through seroTrack, the same emitter sections/article-product-cta.liquid uses):
       toc_click        { article_handle, article_hub, slot }   slot = s1..sN or faq
       section_reached  { article_handle, article_hub, slot }   once per section per page view
       scent_vote       { article_handle, article_hub, scent, direction }   direction = up, down or clear
       vote_email_view  { article_handle, article_hub, scent }  once, when the email step is on screen
       vote_email_submit{ article_handle, article_hub, scent }  once, when Klaviyo accepts the email
     (scent on the two email events is the scent most recently tapped.)
     article_handle is Shopify's article.handle, which is already "hub/handle".
     The existing article_scroll_depth and article_read_complete events are untouched.
   - Early door: one-click add of The Scent Sampler (article_module_click, slot early_door).
   - Scent vote: a thumbs up or down per scent, one state per scent per browser (localStorage),
     then the email step, which posts to Klaviyo's client subscriptions API with the list, source and
     company set on the section (data attributes), never a hardcoded id here.
   The article-specific diagram behaviors in kit/kit.js (diagnostic, motion diagrams) belong to
   those components and ship with them in Waves 3 and 4. */
(function () {
  'use strict';
  var root = document.querySelector('[data-sk-article]');
  if (!root || root.getAttribute('data-sk-ready') === '1') return;
  root.setAttribute('data-sk-ready', '1');

  var HANDLE = root.getAttribute('data-sk-article') || '';
  var HUB = root.getAttribute('data-sk-hub') || '';

  function seroTrack(name, params) {
    try { if (typeof window.gtag === 'function') { window.gtag('event', name, params); } } catch (err) {}
    var _dl = (window.dataLayer = window.dataLayer || []);
    var payload = { event: name };
    for (var k in params) { if (Object.prototype.hasOwnProperty.call(params, k)) payload[k] = params[k]; }
    _dl.push(payload);
  }
  function P(extra) {
    var p = { article_handle: HANDLE, article_hub: HUB };
    for (var k in extra) { if (Object.prototype.hasOwnProperty.call(extra, k)) p[k] = extra[k]; }
    return p;
  }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- toc_click (rail and inline list) ---------- */
  root.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-sk-toc] a[data-sk-slot]') : null;
    if (a) seroTrack('toc_click', P({ slot: a.getAttribute('data-sk-slot') }));
  });

  /* ---------- section_reached: once per section per view ---------- */
  var secs = $$('[data-sk-sec]', root);
  if ('IntersectionObserver' in window && secs.length) {
    var seen = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var slot = en.target.getAttribute('data-sk-sec');
        io.unobserve(en.target);
        if (seen[slot]) return;
        seen[slot] = 1;
        seroTrack('section_reached', P({ slot: slot }));
      });
    }, { rootMargin: '0px 0px -35% 0px', threshold: 0 });
    secs.forEach(function (s) { io.observe(s); });
  }

  /* ---------- Rail: current section, progress, kept in view ---------- */
  var rail = root.querySelector('.sk-rail');
  var railLinks = rail ? $$('a[data-sk-slot]', rail) : [];
  var bar = rail ? rail.querySelector('.sk-rail__bar i') : null;
  var col = root.querySelector('.sk-col');
  if (rail && railLinks.length) {
    var targets = railLinks.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
    var current = -1, ticking = false;
    var update = function () {
      ticking = false;
      if (rail.offsetParent === null) return; /* rail hidden below 1040px */
      var line = window.innerHeight * 0.35, idx = -1;
      for (var i = 0; i < targets.length; i++) {
        if (targets[i] && targets[i].getBoundingClientRect().top <= line) idx = i;
      }
      if (idx !== current) {
        current = idx;
        railLinks.forEach(function (a, j) { if (j === idx) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
        if (idx > -1 && rail.scrollHeight > rail.clientHeight) {
          var a = railLinks[idx], top = a.offsetTop - rail.offsetTop, bottom = top + a.offsetHeight;
          if (top < rail.scrollTop + 40 || bottom > rail.scrollTop + rail.clientHeight - 40) {
            rail.scrollTop = Math.max(0, top - rail.clientHeight / 3);
          }
        }
      }
      if (bar && col) {
        var r = col.getBoundingClientRect(), h = r.height - window.innerHeight;
        var p = Math.min(1, Math.max(0, -r.top / (h > 0 ? h : 1)));
        bar.style.transform = 'scaleX(' + p + ')';
      }
    };
    var onScroll = function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ---------- Early door: The Scent Sampler, one click ----------
     The sets rail's behavior (sections/shop-d1-sets.liquid): add the Sampler with one of each scent,
     Adding... then Added to cart, and the theme's refreshCart() opens the cart drawer. A failed add
     falls back to the product URL, as the rail's does. The click fires article_module_click as the
     article-end product module does, with slot early_door so the two can be told apart. */
  $$('[data-sk-sampler-atc]', root).forEach(function (btn) {
    var lbl = btn.querySelector('span') || btn;
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      seroTrack('article_module_click', P({ slot: 'early_door' }));
      btn.disabled = true;
      lbl.textContent = btn.getAttribute('data-adding');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-variant'), 10), quantity: 1,
          properties: { 'Scents': 'One of each (Renew, Uplift, Unwind)' } }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        btn.setAttribute('data-state', 'added');
        lbl.textContent = btn.getAttribute('data-added');
        btn.disabled = false;
        if (typeof window.refreshCart === 'function') { window.refreshCart(); }
        else { window.location.href = '/cart'; }
      }).catch(function () {
        btn.disabled = false;
        lbl.textContent = btn.getAttribute('data-label');
        window.location.href = btn.getAttribute('data-fallback');
      });
    });
  });

  /* ---------- Scent vote: thumbs up or down per scent ----------
     One state per scent per browser: localStorage sk-votes, {"<id>": "up" | "down"}, the most recent
     rating last. Up and down are mutually exclusive; a tap on the pressed one clears it. Every tap sends
     scent_vote {scent, direction: up | down | clear}. The first tap reveals the email ask, and
     vote_email_view fires once when the ask is half on screen. The email posts to Klaviyo's client
     subscriptions API with profile properties scent_votes (id to up or down), next_scent_vote (the most
     recent thumbs-up, when there is one) and vote_article. Counts exist only when the section rendered
     them from the weekly tally; each shows the tally plus the visitor's own vote. */
  var vote = root.querySelector('[data-sk-vote]');
  if (vote) {
    var KEY = 'sk-votes', KEY_E = 'sk-vote-email';
    var store = function (k, v) {
      try { if (v === undefined) return window.localStorage.getItem(k); window.localStorage.setItem(k, v); } catch (err) {}
      return null;
    };
    var rows = $$('.sk-ballot__row[data-c]', vote);
    var ids = rows.map(function (r) { return r.getAttribute('data-c'); });
    var ask = vote.querySelector('[data-sk-vote-ask]');
    var form = vote.querySelector('[data-sk-vote-form]');
    var done = vote.querySelector('[data-sk-vote-done]');
    var errEl = vote.querySelector('[data-sk-vote-err]');
    var state = {}, last = null, askViewed = false, watching = false;
    try {
      var saved = JSON.parse(store(KEY) || '{}');
      if (saved && typeof saved === 'object') {
        Object.keys(saved).forEach(function (c) {
          if (ids.indexOf(c) > -1 && (saved[c] === 'up' || saved[c] === 'down')) { state[c] = saved[c]; last = c; }
        });
      }
    } catch (err) { state = {}; }
    var lastUp = function () {
      var u = null;
      Object.keys(state).forEach(function (c) { if (state[c] === 'up') u = c; });
      return u;
    };
    var render = function () {
      rows.forEach(function (r) {
        var v = state[r.getAttribute('data-c')] || '';
        if (v) r.classList.add('is-rated'); else r.classList.remove('is-rated');
        $$('[data-dir]', r).forEach(function (b) {
          var on = v === b.getAttribute('data-dir');
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          var n = b.parentNode.querySelector('[data-base]');
          if (n) n.textContent = String((parseInt(n.getAttribute('data-base'), 10) || 0) + (on ? 1 : 0));
        });
      });
    };
    var showDone = function () {
      if (form) form.hidden = true;
      if (done) done.hidden = false;
      if (errEl) errEl.hidden = true;
      if (ask) ask.classList.add('is-done'); /* the panel keeps only the thanks lines */
    };
    var watchAsk = function () {
      if (watching || askViewed || !ask) return;
      watching = true;
      var fire = function () { if (askViewed) return; askViewed = true; seroTrack('vote_email_view', P({ scent: last })); };
      if (!('IntersectionObserver' in window)) { fire(); return; }
      var aio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var need = Math.min(en.boundingClientRect.height, window.innerHeight) * 0.5;
          if (en.isIntersecting && en.intersectionRect.height >= need) { aio.disconnect(); fire(); }
        });
      }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
      aio.observe(ask);
    };
    var reveal = function () {
      vote.classList.add('is-voted');
      if (store(KEY_E) === '1') { showDone(); } else { watchAsk(); }
    };

    render();
    if (Object.keys(state).length) reveal();

    rows.forEach(function (r) {
      var c = r.getAttribute('data-c');
      $$('[data-dir]', r).forEach(function (b) {
        b.addEventListener('click', function () {
          var d = b.getAttribute('data-dir');
          var direction = state[c] === d ? 'clear' : d;
          delete state[c];
          if (direction !== 'clear') state[c] = d; /* re-added, so the most recent rating is the last key */
          store(KEY, JSON.stringify(state));
          last = c;
          render();
          seroTrack('scent_vote', P({ scent: c, direction: direction }));
          reveal();
        });
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input[type="email"]');
        var submit = form.querySelector('button[type="submit"]');
        if (!input || !input.checkValidity()) { if (input && input.reportValidity) input.reportValidity(); return; }
        if (submit) submit.disabled = true;
        if (errEl) errEl.hidden = true;
        var votes = {};
        Object.keys(state).forEach(function (c) { votes[c] = state[c]; });
        var props = { scent_votes: votes, vote_article: HANDLE };
        var up = lastUp();
        if (up) props.next_scent_vote = up;
        var body = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: vote.getAttribute('data-source'),
              profile: { data: { type: 'profile', attributes: { email: input.value.trim(), properties: props } } }
            },
            relationships: { list: { data: { type: 'list', id: vote.getAttribute('data-list') } } }
          }
        };
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(vote.getAttribute('data-company')), {
          method: 'POST',
          /* Payload, content type and revision checked against Klaviyo's published OpenAPI spec (stable 2026-07-15). */
          headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-07-15' },
          body: JSON.stringify(body)
        }).then(function (r) {
          if (!r.ok) throw new Error('status ' + r.status);
          store(KEY_E, '1');
          seroTrack('vote_email_submit', P({ scent: last }));
          showDone();
        }).catch(function () {
          if (errEl) errEl.hidden = false;
          if (submit) submit.disabled = false;
        });
      });
    }
  }
})();
